import { Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const Users = () => {
  return (
    <>
      <Helmet>
        <title>Team Members | MindShare Calendar</title>
      </Helmet>
      <Container maxWidth="lg">
        <Typography variant="h4" component="h1" gutterBottom>
          Team Members
        </Typography>
        
        {/* Rest of the existing content */}
      </Container>
    </>
  );
};

export default Users; 